
    import * as React from 'react';

    const SocialPhone16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M4 1h8v14H4V1zm4 13a.5.5 0 100-1 .5.5 0 000 1zM5 2v10h6V2H5z" /></svg>
        </div>
      );
    };

    SocialPhone16.displayName = 'SocialPhone16';

    export default SocialPhone16;
  